module.exports = __webpack_public_path__ + "img/Weapon_302.f124c019.png";